
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Platform, SportType, SraPlacement } from '@/@types/graphql-types';
import SponsoredRecommendationSports from '@/components/sponsored-recommendations/SponsoredRecommendationSports.vue';
import SingleStepEventEncounterList from '@/components/sports/common/SingleStepEventEncounterList.vue';
import SportsLayout from '@/components/sports/common/SportsLayout.vue';
import { getSportPageContext } from '@/helpers/sports/config';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { SportPageType } from '@/interfaces/sport-graphql';
import {
	GetSportsEventsListDocument,
	GetSportsEventsListQueryVariables,
} from '@/pages/graphql/queries/GetSportsEventsList.query';
import HiddenHorizontalScrollbar from '../HiddenHorizontalScrollbar.vue';
import ProvideUpcomingSportEvents from '../sports/single-step/ProvideUpcomingSportEvents.vue';
import { getAllowSponsoredRecommendations } from './useSponsoredRec';

const Language = namespace('language');
const Routing = namespace('routing');

@Component({
	name: 'SrSportsList',
	components: {
		HiddenHorizontalScrollbar,
		ProvideUpcomingSportEvents,
		SingleStepEventEncounterList,
		SponsoredRecommendationSports,
		SportsLayout,
	},
	apollo: {
		upcomingEvents: {
			query: GetSportsEventsListDocument,
			variables(): GetSportsEventsListQueryVariables {
				return this.queryVariables;
			},
			update(data) {
				console.log('DATA', data);
				const result = data.sportEventsV2.edges.map((edge: any) => edge.node);
				return result;
			},
		},
		watchLoading(isLoading: boolean) {
			this.isLoading = isLoading;
		},
	},
})
export default class SrSportsList extends Vue {
	upcomingEvents: any = [];
	isLoading: boolean = false;

	@Language.Getter country: string;
	@Language.Getter language: string;

	@Routing.Getter currentPageType: string;

	get sportContext() {
		return [new SnowplowSportContext(this.context.sportType, this.context.pageType)];
	}

	get context() {
		return getSportPageContext({
			sport: SportType.Football,
			pageType: SportPageType.SportOverview,
		});
	}

	get events() {
		return this.upcomingEvents;
	}

	get queryVariables(): GetSportsEventsListQueryVariables {
		return {
			country: this.country,
			language: this.language,
			timezoneOffset: 0,
			filter: {
				sports: [SportType.Football],
			},
			platform: Platform.Web,
			allowSponsoredRecommendations: getAllowSponsoredRecommendations({
				pageType: this.currentPageType,
				placement: SraPlacement.SportCompetitionPage,
			}),
		};
	}

	get showList() {
		return this.country.toLowerCase() === 'de';
	}
}
